import { useMedia } from 'react-media';

import { GLOBAL_MEDIA_QUERIES } from '../utils/mediaQueries';

export function useMediaQuery(): { desktop: boolean; mobile: boolean } {
  return useMedia({ queries: GLOBAL_MEDIA_QUERIES });
}
